import React, { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { programDetailData } from "../../../types/programData";
import RegionProgress from "./regionProgres";

const FokusDetail: React.FC = () => {
  const IconArrow = FaArrowRight as React.FC<React.SVGProps<SVGSVGElement>>;
  const { slug } = useParams();
  const program = programDetailData.find((p) => p.slug === slug);

  useEffect(() => {
    if (program) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [slug, program]);

  if (!program) return <Navigate to="/" replace />;

  return (
    <section className="py-24 max-sm:py-12 px-6">
      <div className="max-w-6xl mx-auto">
        {/* HEADER */}
        <div className="mb-12">
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Program <span className="text-red-600">{program.title}</span>
          </h1>
          <p className="mt-3 text-xl text-gray-700 font-medium">{program.subtitle}</p>
          <p className="mt-4 text-gray-600 max-w-3xl">{program.description}</p>
        </div>

        {/* CONTENT */}
        <div className="bg-white rounded-3xl  shadow-sm space-y-12">
          {/* SECTIONS */}
          {program.sections.map((section, index) => (
            <div key={index}>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">{section.title}</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">{section.description}</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {section.targets.map((item, i) => (
                  <div key={i} className="bg-red-50 border border-red-100 rounded-xl px-5 py-4 text-sm font-semibold text-red-700 shadow-sm">
                    {item}
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* STATS */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {program.stats.map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-6 text-center border">
                <h3 className="text-3xl font-extrabold text-red-600">{item.value}</h3>
                <p className="mt-2 text-sm text-gray-600">{item.label}</p>
              </div>
            ))}
          </div>

          <div className="my-4">
            {" "}
            <RegionProgress />
          </div>

          {/* CTA */}
          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t pt-8">
            <p className="text-gray-700 max-w-xl">Mari ambil peran dalam gerakan kemanusiaan ini melalui penggalangan dana yang transparan dan berdampak nyata.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/regioncheck"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 border border-red-600 text-red-600 
                         px-6 py-4 rounded-xl font-semibold
                         hover:bg-red-100 transition shadow-md">
                Lihat Region Check
                <IconArrow />
              </Link>

              <Link
                to="https://belaskasih.com/account/campaign/new"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-red-600 text-white
                         px-6 py-4 rounded-xl font-semibold
                         hover:bg-red-700 transition shadow-md">
                Galang Dana Sekarang
                <IconArrow />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FokusDetail;
